import React, { useEffect, useState } from 'react'
import { Button, Grid, Typography } from '@material-ui/core'

import { useAsyncPrint } from 'src/components/ToPrint/useAsyncPrint'
import { BulkPrint } from 'src/components/Print/Bulk'
import { RetailerLabel } from 'src/modules/supply_chain/components/retailers/RetailerLabel'

import { GenericCard } from '../ModelCard'
import { CaseLabelPrintingHandler } from 'src/scanRouter/handlers'

interface LabelPrintingDisplayProps {
  handler: CaseLabelPrintingHandler
}

export const CaseLabelPrintingDisplay = (props: LabelPrintingDisplayProps) => {
  const { handler } = props
  const [, refresh] = useState({})
  const { print, renderPrintComponent } = useAsyncPrint()

  useEffect(() => {
    const cb = () => {
      refresh({})
    }
    handler.registerCb(cb)
    return () => handler.removeCb(cb)
  }, [handler, refresh])

  if (!handler.obj?.object || !handler.obj?.object) {
    return null
  }

  const printLabel = () => {
    const labelData = handler.shipmentUnit?.object.retailerLabels
    print((props) => (
      <BulkPrint
        {...props}
        items={labelData}
        render={({ obj, onReadyToPrint }) => {
          onReadyToPrint?.()
          return <RetailerLabel data={obj.label_data} />
        }}
      />
    ))
    handler.printed()
  }

  return (
    <>
      {renderPrintComponent()}
      <Grid container justify="center">
        <Grid item xs={12}>
          <Typography>Printing case labels for...</Typography>
        </Grid>
        <Grid item xs={12}>
          <GenericCard item={handler.obj} />
        </Grid>
        <Grid item xs={12}>
          <Typography>Scan container to print a label for...</Typography>
        </Grid>
        {handler.container && (
          <>
            <Grid item xs={12}>
              <GenericCard item={handler.container} />
            </Grid>
            <Grid item xs={12}>
              <Typography>Scan product to print a label for...</Typography>
            </Grid>
          </>
        )}
        {handler.shipmentUnit && handler.product && (
          <>
            <Grid item xs={12}>
              <GenericCard item={handler.product} />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                onClick={printLabel}
              >
                Print Label
              </Button>
            </Grid>
          </>
        )}
      </Grid>
    </>
  )
}
